import {
  ProductVariantLiteModel,
  getProductVariantsKey,
  useGetProductVariants,
} from 'api-hooks/product/list';
import { Option } from 'baseui/select';
import { NavigationRoutes } from 'common/constants';
import { ModelTransformer } from 'common/helpers/common';
import { ColumnDataType } from 'components/elements/table/type';

import useGetCrudPermission from './use-get-crud-permission';
import useNavigation from './use-navigation';

function productVariantTransformer(
  item: ProductVariantLiteModel,
  sales = true,
): Option {
  return {
    id: item.id,
    label: item.completeName,
    extra: item,
    disabled: sales && item.stock <= 0,
  };
}

export default function useGetProductVariantColumn(sales = true) {
  const permission = useGetCrudPermission('products');
  const { navigate } = useNavigation();
  return {
    dataType: ColumnDataType.select,
    useListQueryHook: useGetProductVariants,
    listKeyFunction: getProductVariantsKey,
    getMemoizedListVariables: (page, q) => ({
      params: {
        q,
        page,
      },
    }),
    listTransformer: (result) => {
      return result.data.map((v) => {
        const data = ModelTransformer(v, ProductVariantLiteModel);
        return productVariantTransformer(data, sales);
      });
    },
    paginationTransformer: (result) => {
      return result.meta;
    },
    renderCreate: permission.create,
    onClickCreate: () => {
      navigate(NavigationRoutes.ProductsCreate);
    },
  };
}
